/*==========================================================
MAIN NAV SCRIPTS
==========================================================*/

// Options
const mainNavTrigger = "click", // 'click' or 'hover'
  dropdownToggleClass = "sfHover"; // same class as superfish for CSS consistency between different trigger types

// Elements
let $nav = $("#nav"),
  $navItem = $nav.find("> li");

$(function () {
  mainNavClick();

  // Configure main nav trigger
  if (mainNavTrigger == "hover") {
    mainNavHover();
  }

  // Mobile Nav Trigger
  $(".mobileNav")
    .find(".menuTrigger")
    .on("click", function () {
      $(this).attr(
        "aria-expanded",
        $(this).attr("aria-expanded") === "false" ? "true" : "false"
      );
      $("#mainNav")
        .slideToggle()
        .attr(
          "aria-hidden",
          $(this).attr("aria-expanded") === "true" ? "false" : "true"
        );
    });
    
    $(document).on('focusin', function (e) {
        if (!$(e.target).closest('#mainNav').length && !$(e.target).is('.menuTrigger') && $('#mainNav').is(':visible')) {
            $('#mainNav').hide().attr('aria-hidden', 'true');
            $(".mobileNav .menuTrigger").attr('aria-expanded', 'false');
        }
    });
});

function mainNavClick() {
  $nav.addClass("nav--click");

  $.fn.slideToggleBool = function (bool, options) {
    return bool ? $(this).slideDown(options) : $(this).slideUp(options);
  };

  function navCloseDropdown() {
    $navItem
      .find(".dropDownContainer")
      .slideToggleBool(false, 240)
      .parent("li")
      .removeClass(dropdownToggleClass)
      .find("> a:not(.extendedMenu), .mainNavItem_expander")
      .attr("aria-expanded", false);

      remove_trap_focus($navItem, 'mainNavFocus');
  }

  function navClickDropdown(bindClick) {
    $navItem.each(function (index) {
      let $dropdown = $(this).find(".dropDownContainer");

      if ($dropdown.length) {
        const dropdownID = $dropdown.attr("id") ? $dropdown.attr("id") : "navItemDropdown" + index;
        const dropdownToggleEls = $(this).find(">.mainNavItem, >.mainNavItem_expander");

        $dropdown.attr("id", dropdownID);
		dropdownToggleEls.attr({
			"aria-controls": dropdownID,
			"aria-expanded": false,
			"aria-haspopup": true,
			"role": 'button'
		});

        if (bindClick) {
          dropdownToggleEls.click(function (event) {
            event.preventDefault();
            event.stopPropagation();

            let wasOpen = $(this)
              .parent("li")
              .find(".dropDownContainer")
              .is(":visible");

            // Close all dropdowns
            $navItem
              .find(".dropDownContainer")
              .slideToggleBool(false, 240)
              .parent("li")
              .removeClass(dropdownToggleClass)
              .find('> [aria-expanded="true"]')
              .attr("aria-expanded", "false");

              remove_trap_focus($navItem, 'mainNavFocus');

              if ($(window).width() >= 1200) {
                  var headerInnerH = $('#headerInner').outerHeight(),
                      headerRightH = $('#headerRight').outerHeight(),
                      ratio = ((headerRightH + parseInt($('#headerInner').css('padding-top'))) / headerInnerH * 100).toFixed(2) + '%';

                  $dropdown.css('top', ratio);
              } else {
                  $dropdown.css('top', '');
              }

            // Open clicked dropdown if it wasn't just closed
            if (!wasOpen) {
              trap_focus($(this).parent("li"), 'mainNavFocus');
              $(this).parent("li").toggleClass(dropdownToggleClass);
              $dropdown.slideToggleBool(true, 240);
              $(this).attr("aria-expanded", function(i, attr){
				return attr === 'false' ? 'true' : 'false';
			  }).siblings('a, button').attr("aria-expanded", function(i, attr){
				return attr === 'false' ? 'true' : 'false';
			  });
            }
          });
        }
      }
    });
  }

  navClickDropdown(true);

  let windowW = $(window).width();

  //debounce resize instead of standard resize
  $(window).debounceResize(function () {
	// make sure the fn only be called on horizontal window size change
	if ($(window).width() !== windowW) {
		navCloseDropdown();
		navClickDropdown();
	}

	windowW = $(window).width();
  });

  // Close dropdown if clicked outside of it
  $(document).on("click", function (event) {
	if (!$(event.target).closest('.dropDownContainer:visible').length) {
		navCloseDropdown();
	}

    if ($(this).is("#sahreBtn")) {
      return;
    }
  });
}

function mainNavHover() {
  $.getScript(
    "https://js.esolutionsgroup.ca/js/libs/hover-intent/1.8.0/jquery.hoverIntent.min.js",
    function () {
      $.getScript(
        "https://js.esolutionsgroup.ca/js/libs/jquery_superfish/1.7.4/superfish.min.js",
        function () {
          $nav.addClass("nav--hover");
          mainNavHoverFn();
        }
      );
    }
  );
}

function mainNavHoverFn() {
  if (window.matchMedia("(max-width: 991px)").matches) {
    $nav.superfish("destroy");
  } else {
    $navItem.removeClass("mobile-open");
    $nav.superfish({
      cssArrows: false,
      speed: "normal",
      speedOut: "fast",
    });
  }

  //debounce resize instead of standard resize
  $(window).debounceResize(function () {
    mainNavHoverFn();
  });
}
